import { render } from "./clueCollection.vue?vue&type=template&id=3a1c0da4&scoped=true"
import script from "./clueCollection.vue?vue&type=script&lang=js"
export * from "./clueCollection.vue?vue&type=script&lang=js"

import "./clueCollection.vue?vue&type=style&index=0&id=3a1c0da4&scoped=true&lang=css"
import "./clueCollection.vue?vue&type=style&index=1&id=3a1c0da4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3a1c0da4"

export default script